import React from "react"
import styled, { keyframes } from "styled-components"

const ALL_SITUATIONS = [
  "입사 인사",
  "메일 제목",
  "부고 위로",
  "응원 인사",
  "고객 응대",
  "검토 요청",
  "면접 거절",
  "퇴사 인사",
  "생일 축하",
  "회의 공지",
  "건배사",
  "계절 인사",
  "아침 인사",
  "결혼 축하",
  "명절 인사",
  "퇴사응원",
  "업무요청",
  "새해 인사",
  "연말 인사",
  "감사 인사",
  "업무 보고",
  "자료 전달",
  "월요일 인사",
  "첫인사",
  "추석 인사",
  "조문 답례",
  "병문안 위로",
  "담당자 변경",
  "부재 공유",
  "연차 신청",
  "회식 안내",
  "미팅 요청",
  "피드백 전달",
  "협업 요청",
  "일정 조율"
]

const SITUATIONS = ALL_SITUATIONS.filter(s => s.length <= 7)

const COUNT = SITUATIONS.length
const HOLD = 2.5
const SLIDE = 0.45
const TOTAL = COUNT * (HOLD + SLIDE)

function buildKeyframes() {
  const step = 100 / COUNT
  const slideP = (SLIDE / (HOLD + SLIDE)) * step

  let frames = ""
  for (let i = 0; i < COUNT; i++) {
    const holdStart = step * i
    const holdEnd = step * i + (step - slideP)
    const slideEnd = step * (i + 1)
    const y = i * (100 / (COUNT + 1))
    const yNext = (i + 1) * (100 / (COUNT + 1))

    frames += `${holdStart.toFixed(2)}% { transform: translateY(-${y.toFixed(
      2
    )}%); }\n`
    frames += `${holdEnd.toFixed(2)}% { transform: translateY(-${y.toFixed(
      2
    )}%); }\n`

    if (i < COUNT - 1) {
      frames += `${slideEnd.toFixed(
        2
      )}% { transform: translateY(-${yNext.toFixed(2)}%); }\n`
    } else {
      frames += `100% { transform: translateY(-${yNext.toFixed(2)}%); }\n`
    }
  }
  return frames
}

const rotate = keyframes`${buildKeyframes()}`

function RotatingText() {
  return (
    <Wrapper>
      <Track>
        {SITUATIONS.map((text, i) => (
          <Item key={i}>{text}</Item>
        ))}
        <Item>{SITUATIONS[0]}</Item>
      </Track>
    </Wrapper>
  )
}

const Wrapper = styled.span`
  display: inline-block;
  height: 1.3em;
  overflow: hidden;
  vertical-align: bottom;
  position: relative;

  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 20%,
    #000 80%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #000 20%,
    #000 80%,
    transparent 100%
  );
`

const Track = styled.span`
  display: flex;
  flex-direction: column;
  animation: ${rotate} ${TOTAL}s cubic-bezier(0.65, 0, 0.35, 1) infinite;
`

const Item = styled.span`
  display: block;
  height: 1.3em;
  line-height: 1.3;
  white-space: nowrap;
  color: #5551ff;
  text-align: center;
`

export default RotatingText
